import { Component, Inject, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'
import { FieldTree, form, required } from '@angular/forms/signals'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { NaytettavaKirjaus } from '../kirjanpito.component'

import { StringService } from '@lemon/core/service/string.service'
import { ViitenumeroService } from '@lemon/core/service/viitenumero.service'
import { arvonMuutokset } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'
import { validoiReaktiivisesti } from 'app/_jaettu-angular/_lomakkeet/reaktiivinen-validaattori'
import { FormValidationService } from 'app/_jaettu-angular/service/form-validation.service'
import { Asiakas } from 'app/_jaettu-lemonator/model/asiakas'

export interface KirjausMuokkaaViitenumeroaDialogData {
  naytettavaKirjaus: NaytettavaKirjaus
  asiakas: Asiakas
}

interface ViitenumeroLomake {
  viitenumero: string
}

@Component({
  templateUrl: './kirjaus.muokkaa-viitenumeroa.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class KirjausMuokkaaViitenumeroaDialog implements OnInit {
  lomake: FieldTree<ViitenumeroLomake>

  private _uusiViitenumero: string = null

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: KirjausMuokkaaViitenumeroaDialogData,
    private _dialogRef: MatDialogRef<KirjausMuokkaaViitenumeroaDialog>,
    private _formValidationService: FormValidationService,
    private _viitenumeroService: ViitenumeroService,
    private _stringService: StringService,
  ) {
    this.lomake = form(signal<ViitenumeroLomake>({ viitenumero: this.data.naytettavaKirjaus.kirjaus.kirjauksenViitenumero ?? '' }), polku => {
      required(polku.viitenumero)
      validoiReaktiivisesti(polku.viitenumero, this._validateViitenumero)
    })
    arvonMuutokset(this.lomake.viitenumero).subscribe(value => {
      const muotoiltu = this._viitenumeroService.muotoileViitenumero(value) // Poistaa etunollat jne.
      const whitespacePoistettu = this._stringService.removeAllWhiteSpaces(muotoiltu)
      this._uusiViitenumero = whitespacePoistettu
    })
  }

  ngOnInit() {}

  tallenna() {
    if (this.lomake().invalid()) {
      this._formValidationService.merkitseKokoLomakeKosketuksi(this.lomake)
      return
    }

    if (!this._uusiViitenumero || this.data.naytettavaKirjaus.kirjaus.maksutavanTunniste === this._uusiViitenumero) {
      this.data.naytettavaKirjaus.uusiViitenumero = null
    } else {
      this.data.naytettavaKirjaus.uusiViitenumero = this._uusiViitenumero
    }

    this._dialogRef.close(true)
  }

  onkoVirhe<T>(kentta: FieldTree<T>, laji: string): boolean {
    return kentta()
      .errors()
      .some(virhe => virhe.kind === laji)
  }

  private _validateViitenumero: ValidatorFn = (ctrl: AbstractControl): ValidationErrors | null => {
    if (ctrl.value == null || ctrl.value === undefined || ctrl.value.trim() === '') {
      return null
    }
    if (!this._viitenumeroService.onkoViitenumeroValidi(ctrl.value)) {
      return { viitenumero: true }
    }
    return null
  }
}
